import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M20.1 2.5a.6.6 0 1 0-1.2 0v19a.6.6 0 1 0 1.2 0v-19Zm-5.6 10.1a.6.6 0 1 0 0-1.2H5.948l3.976-3.976a.6.6 0 1 0-.848-.848l-5 5a.6.6 0 0 0 0 .848l5 5a.6.6 0 0 0 .848-.848L5.948 12.6H14.5Z"
    />
  </svg>
`;
